import { Box, LoadingOverlay } from '@mantine/core';
import { observer } from 'mobx-react-lite';

import { useOrders } from '../cabinet/features/orders/orders.provider';
import { AddFeedbackForm } from './add-feedback-form';
import { useAddOrderFeedback } from './use-add-order-feedback';

export const AddFeedback = observer(({ orderId }: { orderId: number }) => {
  const { ordersStore } = useOrders();
  const addFeedbackRequest = useAddOrderFeedback({
    onFeedbackAdded: (feedback) => {
      ordersStore.updateOrderFeedback(feedback);
    },
  });

  return (
    <Box pos="relative">
      <LoadingOverlay visible={addFeedbackRequest.loading} />

      <AddFeedbackForm
        onSubmit={(feedback) =>
          addFeedbackRequest.addFeedback({
            orderId,
            rating: feedback.rating,
            description: feedback.message,
          })
        }
      />
    </Box>
  );
});
